export default "__VITE_ASSET__69dc2033__"